import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Token.svg",
  "use": "Token.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Token.svg\"><path d=\"M32,56A24,24,0,1,1,56,32,24,24,0,0,1,32,56Zm3.9624-29.0082-2.6956-8.07a1.3448,1.3448,0,0,0-2.5362,0l-2.6956,8.07H19.337a1.2945,1.2945,0,0,0-.78,2.3533l7.028,4.9384-2.5028,7.9714a1.3143,1.3143,0,0,0,2.0085,1.4978L31.9987,38.78l6.9073,4.9843a1.3143,1.3143,0,0,0,2.01-1.4963l-2.5035-7.9869,7.0265-4.9354a1.2945,1.2945,0,0,0-.78-2.3535Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol